import { CommonModule, DatePipe } from '@angular/common';
import {Component, Input, OnInit, inject, Output, EventEmitter} from '@angular/core';
import {
  FormArray,
  FormControl,
  FormGroup,
  FormGroupDirective,
  ReactiveFormsModule,
  Validators,
} from '@angular/forms';
import { faAdd } from '@fortawesome/free-solid-svg-icons';
import {Subject, Subscription} from 'rxjs';
import { Course, Subsection } from 'src/app/admin/data-access/course.model';
import { CourseService } from 'src/app/admin/data-access/course.service';
import { TooltipDirective } from 'src/app/shared/ui/tooltip/tooltip.component';
import {OutlineButtonComponent} from "../../../../shared/ui/outline-button/outline-button.component";
import {ExamService} from "../../../data-access/exam.service";
import {MatSnackBar} from "@angular/material/snack-bar";
import {MatCheckbox} from "@angular/material/checkbox";
import {MatLabel} from "@angular/material/input";
import {AuthService} from "../../../../login/data-access/auth.service";

enum AssessmentTypes {
  exam = 'exam',
  quiz = 'quiz',
  homework = 'homework',
}

@Component({
    selector: 'app-exam-assign',
    templateUrl: './assign.component.html',
    providers: [DatePipe],
  imports: [CommonModule, ReactiveFormsModule, TooltipDirective, OutlineButtonComponent, MatCheckbox, MatLabel]
})
export class AssignComponent implements OnInit {
  @Input() formGroupName!: string;
  @Input() isEdit: boolean = false
  subsections: Subsection[] = [];
  rootFormGroup = inject(FormGroupDirective);
  assignFormSection!: FormGroup;
  construct!: FormGroup;
  faAdd = faAdd;
  disabledButton = true;
  courses: Course[] = [];
  authService = inject(AuthService);
  examAdmin = false

  get attemptsMaxControl(): FormControl<number> {
    return this.construct.controls['attemptsMax'] as FormControl<number>;
  }

  currentDateTime = '';

  is_classroom = false;

  userPermissionSub: Subscription = this.authService.userDashboard$.subscribe((user) => {
    this.examAdmin = user.result.some(el => el.ui === 'ExamAdmin')
    this.is_classroom = user.result.some(el => el.ui === 'ClassroomAdmin')
  })

  onSubsectionSelected: Subject<void> = new Subject<void>();

  @Output() subsectionsList = new EventEmitter<Subsection[]>();
  @Output() coursesList = new EventEmitter<Course[]>();


  constructor(
    private courseService: CourseService,
    private examService: ExamService,
    private _snackBar: MatSnackBar,
    private datePipe: DatePipe
  ) {}

  ngOnInit(): void {
    this.construct = this.rootFormGroup.control.get('construct') as FormGroup;
    this.assignFormSection = this.rootFormGroup.control.get(
     'assign'
    ) as FormGroup;

    this.rootFormGroup?.valueChanges?.subscribe(value => {
      this.disabledButton = this.parts?.controls.length > this.timeframes.controls.length ? false : true;
    });
    if(!this.isEdit) {
      this.addTimeframe()
    }
    this.listCourses();

    this.construct.get('course_id')?.setValidators([Validators.required]);
    this.construct.get('exam_title')?.setValidators([Validators.required]);
    this.construct.get('type')?.setValidators([Validators.required]);

    this.currentDateTime = this.datePipe.transform(new Date(), "yyyy-MM-dd'T'HH:mm") || '';
  }

  listCourses() {
    this.courseService.listCoursesByExamEditRole().subscribe((response) => {
      this.courses = response;
      this.coursesList.emit(this.courses);
    });
  }

  get timeframes(): FormArray {
    return this.assignFormSection.get('timeframes') as FormArray;
  }

  get parts(): FormArray {
    return this.construct.get('construct')?.get('general')?.get('parts') as FormArray
  }

  checkIfSelected(index: number, subsection_id: number) {
    if (
      this.timeframes.at(index).get('subsection_id')?.value == subsection_id
    ) {
      return false;
    }

    return this.timeframes.controls.some(
      (timeframe) => timeframe.value.subsection_id == subsection_id
    );
  }

  getSubsectionName(subsection_id: number) {
    return this.subsections.find(
      (subsection) => subsection.subsection_id == subsection_id
    )?.name;
  }

  addTimeframe() {
    const timeframeForm = new FormGroup({
      subsection_id: new FormControl(null, Validators.required),
      first_start: new FormControl(null),
      last_start: new FormControl(null),
      finish_by: new FormControl(null),
    });
    this.timeframes.push(timeframeForm);
  }

  onCourseChange(course_id: number){
    this.construct.get('course_id')?.setValue(course_id)
    if(course_id !== 0) {
      this.listSubsections(course_id)
      this.timeframes.controls[0].get('subsection_id')?.setValue(null);
    }
  }

  onTypeChange(type: string) {
    this.construct.get('type')?.setValue(type)
  }

  listSubsections(course_id: number) {
    this.subsections = []
    this.examService.listSubsections(course_id).subscribe((response) => {
      if(response.success) {
        this.subsections = response.result
        this.subsectionsList.emit(this.subsections)
      } else {
        this._snackBar.open(response.msg, 'Dismiss', {panelClass: ['error-snackbar']})
      }
    })
  }

  protected readonly Number = Number;
  assessmentTypes = AssessmentTypes;
  protected readonly AssessmentTypes = AssessmentTypes;
}
